import { render, staticRenderFns } from "./ReleaseHouse.vue?vue&type=template&id=4fc9da01&scoped=true&"
import script from "./ReleaseHouse.vue?vue&type=script&lang=js&"
export * from "./ReleaseHouse.vue?vue&type=script&lang=js&"
import style0 from "../assets/css/bootstrap.min.css?vue&type=style&index=0&id=4fc9da01&scoped=true&lang=css&"
import style1 from "./ReleaseHouse.vue?vue&type=style&index=1&id=4fc9da01&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc9da01",
  null
  
)

export default component.exports